import { render } from "./lives-of-weavers.vue?vue&type=template&id=21bf6b8b&scoped=true"
import script from "./lives-of-weavers.vue?vue&type=script&lang=js"
export * from "./lives-of-weavers.vue?vue&type=script&lang=js"

import "./lives-of-weavers.vue?vue&type=style&index=0&id=21bf6b8b&lang=css"
import "./lives-of-weavers.vue?vue&type=style&index=1&id=21bf6b8b&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bf6b8b"]])

export default __exports__